(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-kith"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-form-kith')) {
    class ProductFormKith extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.form = this.querySelector('form');
        const variantsEl = document.getElementById('ProductVariants-' + this.sectionId);
        this.variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];

        this.querySelectorAll('.kith-pdp__opt-btn').forEach((btn) => {
          btn.addEventListener('click', () => this.handleOptionClick(btn));
        });

        this.qtyInput = this.querySelector('.kith-pdp__qty-input');
        const decreaseBtn = this.querySelector('[data-qty-decrease]');
        const increaseBtn = this.querySelector('[data-qty-increase]');
        if (decreaseBtn) decreaseBtn.addEventListener('click', () => this.stepQty(-1));
        if (increaseBtn) increaseBtn.addEventListener('click', () => this.stepQty(1));

        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
      }

      stepQty(delta) {
        const current = parseInt(this.qtyInput.value || '1', 10);
        this.qtyInput.value = Math.max(1, current + delta);
      }

      handleOptionClick(btn) {
        const group = btn.closest('.kith-pdp__buttons');
        group.querySelectorAll('.kith-pdp__opt-btn').forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        this.updateVariant();
      }

      getSelectedOptions() {
        const options = [];
        this.querySelectorAll('.kith-pdp__option').forEach((optionEl) => {
          const selected = optionEl.querySelector('.kith-pdp__opt-btn.is-selected');
          options.push(selected ? selected.dataset.value : null);
        });
        return options;
      }

      updateVariant() {
        const selected = this.getSelectedOptions();
        const match = this.variants.find((v) =>
          selected.every((val, i) => val === null || v.options[i] === val)
        );
        const addBtn = document.getElementById('AddToCart-' + this.sectionId);
        const priceEl = document.getElementById('ProductPrice-' + this.sectionId);
        const idInput = document.getElementById('ProductSelectedVariant-' + this.sectionId);
        const skuEl = document.getElementById('ProductSku-' + this.sectionId);
        const invEl = document.getElementById('ProductInventory-' + this.sectionId);
        if (!match) return;

        idInput.value = match.id;
        if (priceEl) {
          const priceCurrent = priceEl.querySelector('.kith-pdp__price-current');
          if (priceCurrent) priceCurrent.textContent = this.formatMoney(match.price);
        }
        if (skuEl && match.sku) skuEl.textContent = match.sku;

        if (invEl) {
          const criticalThreshold = parseInt(invEl.dataset.criticalThreshold || '4', 10);
          const qty = match.inventory_quantity;

          let state = 'instock';
          let text = invEl.dataset.inStockText || 'En stock';

          if (!match.available) {
            state = 'outofstock';
            text = invEl.dataset.outStockText || 'Agotado';
          } else if (match.inventory_management && qty <= criticalThreshold && qty > 0) {
            state = 'critical';
            text = qty === 1
              ? (invEl.dataset.criticalStockTextSingular || 'ÚLTIMA UNIDAD EN TU TALLA')
              : (invEl.dataset.criticalStockText || 'ÚLTIMAS UNIDADES');
          }

          text = text.replace('{{quantity}}', qty);

          invEl.className = 'kith-pdp__inventory kith-pdp__inventory--' + state;

          if (state === 'critical') {
            invEl.innerHTML = '<span class="kith-pdp__inventory-badge">' + text + '</span>';
          } else {
            invEl.textContent = text;
          }
        }

        if (addBtn) {
          const label = addBtn.querySelector('[data-add-btn-text]');
          if (match.available) {
            addBtn.disabled = false;
            if (label) label.textContent = addBtn.dataset.addText || 'Agregar a la bolsa';
          } else {
            addBtn.disabled = true;
            if (label) label.textContent = addBtn.dataset.soldText || 'Agotado';
          }
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }

      formatMoney(cents) {
        try {
          const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CLP';
          return new Intl.NumberFormat(document.documentElement.lang || 'es-CL', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: currency === 'CLP' ? 0 : 2,
          }).format(cents / 100);
        } catch (e) {
          return '$' + (cents / 100).toFixed(2);
        }
      }

      handleSubmit(e) {
        e.preventDefault();
        const addBtn = document.getElementById('AddToCart-' + this.sectionId);
        if (!addBtn || addBtn.disabled) return;
        addBtn.classList.add('is-loading');
        const formData = new FormData(this.form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then((r) => {
            if (!r.ok) throw new Error('add-to-cart-failed');
            return r.json();
          })
          .then(() => {
            addBtn.classList.remove('is-loading');
            addBtn.classList.add('is-added');
            const label = addBtn.querySelector('[data-add-btn-text]');
            if (label) label.textContent = addBtn.dataset.addedText || 'Agregado ✓';
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(() => {
              addBtn.classList.remove('is-added');
              this.updateVariant();
            }, 2000);
          })
          .catch(() => {
            addBtn.classList.remove('is-loading');
            this.form.submit();
          });
      }
    }
    customElements.define('product-form-kith', ProductFormKith);
  }

  (function () {
    document.querySelectorAll('.kith-pdp__image').forEach((img) => {
      img.addEventListener('click', () => img.classList.toggle('is-zoomed'));
    });

    document.querySelectorAll('.kith-pdp__gallery').forEach((gallery) => {
      const slides = Array.from(gallery.querySelectorAll('.kith-pdp__media'));
      const dotsContainer = gallery.parentElement.querySelector('[data-gallery-dots]');
      if (!dotsContainer || slides.length < 2) return;

      dotsContainer.classList.add('has-dots');
      slides.forEach((slide, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'kith-pdp__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Ir a la imagen ' + (i + 1));
        dot.addEventListener('click', () => {
          slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsContainer.appendChild(dot);
      });

      const dots = Array.from(dotsContainer.children);
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const idx = slides.indexOf(entry.target);
              if (idx > -1) {
                dots.forEach((d) => d.classList.remove('is-active'));
                dots[idx].classList.add('is-active');
              }
            }
          });
        },
        { root: gallery, threshold: 0.6 }
      );
      slides.forEach((slide) => observer.observe(slide));
    });

    document.querySelectorAll('[data-open-size-guide]').forEach((btn) => {
      const section = btn.closest('.kith-pdp');
      const modal = section ? section.querySelector('[data-size-guide-modal]') : null;
      if (!modal) return;
      btn.addEventListener('click', () => {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });

    document.querySelectorAll('[data-close-size-guide]').forEach((el) => {
      el.addEventListener('click', () => {
        const modal = el.closest('[data-size-guide-modal]');
        if (modal) modal.hidden = true;
        document.body.style.overflow = '';
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-size-guide-modal]:not([hidden])').forEach((modal) => {
          modal.hidden = true;
          document.body.style.overflow = '';
        });
      }
    });

    const stickyMQ = window.matchMedia('(min-width: 990px)');
    document.querySelectorAll('.kith-pdp').forEach((root) => {
      const cols = [
        root.querySelector('.kith-pdp__gallery'),
        root.querySelector('.kith-pdp__info'),
      ].filter(Boolean);
      const updateSticky = () => {
        cols.forEach((col) => {
          if (!stickyMQ.matches) {
            col.style.top = '';
            return;
          }
          const overflow = col.offsetHeight - window.innerHeight;
          col.style.top = overflow > 0 ? -overflow + 'px' : '0px';
        });
      };
      updateSticky();
      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(updateSticky);
        cols.forEach((col) => ro.observe(col));
      }
      window.addEventListener('resize', updateSticky);
      if (stickyMQ.addEventListener) stickyMQ.addEventListener('change', updateSticky);
    });

    document.querySelectorAll('[data-recommendations-wrap]').forEach((wrap) => {
      const productId = wrap.dataset.productId;
      if (!productId) return;
      const url =
        '/recommendations/products?product_id=' + productId +
        '&limit=4&section_id=related-recommendations';
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          wrap.innerHTML = html;
        })
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiendas-reserved"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-rsv-carousel]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var track = root.querySelector('[data-track]');
      var slides = Array.prototype.slice.call(track.children);
      var dotsEl = root.querySelector('[data-dots]');
      if (slides.length < 2) { root.classList.add('is-single'); return; }

      var dots = slides.map(function (s, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'rsv-store__dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Foto ' + (i + 1));
        d.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); });
        dotsEl.appendChild(d);
        return d;
      });

      function go(dir) {
        var idx = Math.round(track.scrollLeft / track.clientWidth) + dir;
        if (idx < 0) idx = slides.length - 1;
        if (idx >= slides.length) idx = 0;
        track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
      }
      root.querySelector('[data-prev]').addEventListener('click', function () { go(-1); });
      root.querySelector('[data-next]').addEventListener('click', function () { go(1); });

      track.addEventListener('scroll', function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
